import React, { useContext } from 'react';
// eslint-disable-next-line import/no-cycle
import FooterRow from './FooterRow';
import FooterCell from './FooterCell';
// eslint-disable-next-line import/named,import/no-cycle
import { TableContext } from '../../CustomTable';

export default function TableFooter({ margin = '0px' }) {
  const ctx = useContext(TableContext);

  return (
    <div style={{ width: '100%', marginTop: margin, padding: '0 26px 20px 26px', ...ctx.footerStyles }}>
      <FooterRow>
        {ctx.columns().map((column) => (
          <FooterCell key={column.id} alignment={column?.alignment}>
            {column.footer(ctx.data)}
          </FooterCell>
        ))}
      </FooterRow>
    </div>
  );
}
